import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Divider,
  DualIcon,
  FormFieldSet,
  NoData,
  PageTitle,
  SmartTooltip,
} from "../../../../components";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { dateFormator } from "../../../../utils";
import { formatWords2 } from "../../../../utils/stringUtils";
import { fetchAllNotes } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import AddNoteModal from "../../ConfirmedStart/Confirmed/modals/AddNoteModal";
const TableGridMonsterToggleView = ({
  gridData,
  onSelectionChange,
  selected,
  setMonsterClassicApplicantId,
  setDetailsDrawer,
  query,
  keywords,
  source
}) => {
  const [internalSelected, setInternalSelected] = useState(selected || []);
  const [openSkillIds, setOpenSkillIds] = useState([]);
  const [noteModal, setNotesModal] = useState(false);
  const [noteData, setNotesData] = useState({});
  const [hoveredNotes, setHoveredNotes] = useState([]);
  const {
    total: monsterTotal,
    tableResponse: monsterTableResponse,
    fullResponse: monsterFullResponse,
    existingCandidates: matchingCandidatesMonster,
  } = useSelector((state) => state.internalDbES.monster);

  const toggleSkill = (id) => {
    setOpenSkillIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  useEffect(() => {
    setInternalSelected(selected || []);
  }, [selected]);

  const handleSelect = (id) => {
    setInternalSelected((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (internalSelected.length === gridData.length) {
      setInternalSelected([]);
    } else {
      setInternalSelected(gridData.map((row) => row.applicantId));
    }
  };

  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange(internalSelected);
    }
  }, [internalSelected]);

  // const skillsData = {
  //   skills: [
  //     { skillName: "React.js", years: "5.6" },
  //     { skillName: "Next.js", years: "5.6" },
  //     { skillName: "Node.js", years: "3" },
  //     { skillName: "Express.js", years: "3" },
  //     { skillName: "Data Quality", years: "5.6" },
  //     { skillName: "ETL", years: "5.6" },
  //     { skillName: "Reporting Dashboards", years: "3" },
  //     { skillName: "Data Processing", years: "3" },
  //   ],
  // };

  const highlightKeywords = (text = "", keywords = []) => {
    if (!text || !keywords.length) return text;

    // Escape regex special characters in keywords
    const escapedKeywords = keywords.map((k) =>
      k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
    );

    const regex = new RegExp(`(${escapedKeywords.join("|")})`, "gi");

    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <mark key={index} class="highlight">
          {part}
        </mark>
      ) : (
        part
      ),
    );
  };

  const getHoveredNotes = async (notes) => {
    setHoveredNotes([]);
    try {
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
    }
  };

  return (
    // <div className="w-full max-h-[70vh] overflow-y-auto p-4">
    <div className="w-full overflow-y-auto p-4">
      {query?.searchType === "classic" && (
        <>
          {/* Select All Checkbox */}
          {gridData?.length ? (
            <div className="mb-2 flex items-center gap-2">
              <FormFieldSet
                type="checkbox"
                noTitle
                options={[{ label: "", value: "all" }]}
                values={
                  internalSelected.length === gridData.length ? ["all"] : []
                }
                onChange={handleSelectAll}
                multiple
              />
              <span className="text-[14px] text-neutrals-500">Select all</span>
            </div>
          ) : (
            ""
          )}

          {/* Candidate Cards */}
          {gridData?.length ? (
            <div className="flex flex-col gap-2">
              {gridData.map((data) => (
                <div
                  key={data.id}
                  className="flex items-start border-gray-300 border rounded-md p-3 shadow-lg bg-white relative"
                >
                  {/* Left Section */}
                  <div className="flex items-start gap-3 w-full flex-1">
                    <FormFieldSet
                      type="checkbox"
                      noTitle
                      options={[{ label: "", value: data.applicantId }]}
                      values={
                        internalSelected.includes(data.applicantId)
                          ? [data.applicantId]
                          : []
                      }
                      onChange={() => handleSelect(data.applicantId)}
                      multiple
                    />

                    {matchingCandidatesMonster?.some((c) =>
                      c.resumeIds?.some((r) => r.id === data.resumeId),
                    ) && (
                      <div className="absolute right-0 top-0 p-2 text-primary-500 text-sm bg-primary-50">
                        Profile Migrated
                      </div>
                    )}

                    <div className="flex-1 w-full ">
                      <div className="flex gap-3">
                        <PageTitle title={data.name} tag="h5" />
                        <SmartTooltip description={"View Resume"} noicon>
                          <Button
                            type="icon"
                            size="sm"
                            variant="text"
                            icon="visibility"
                            color="black"
                            onClick={() => {
                              setDetailsDrawer(true);
                              setMonsterClassicApplicantId(data.applicantId);
                            }}
                          />
                        </SmartTooltip>
                        {matchingCandidatesMonster?.some((c) =>
                          c.resumeIds?.includes(data.resumeId),
                        ) && (
                          <SmartTooltip description="Migrated" noicon>
                            <Button
                              type="icon"
                              size="sm"
                              variant="text"
                              icon="save"
                              color="black"
                            />
                          </SmartTooltip>
                        )}
                        {matchingCandidatesMonster?.find((c) =>
                          (c?.resumeIds || []).some(
                            (r) => r?.id === data?.resumeId,
                          ),
                        )?.notes?.length > 0 && (
                          <div
                            onMouseEnter={() => {
                              const isMatched = matchingCandidatesMonster?.find(
                                (c) =>
                                  (c?.resumeIds || []).some(
                                    (r) => r?.id === data?.resumeId,
                                  ),
                              );
                              const uiids = isMatched?.notes
                                .filter(
                                  (n) => n && typeof n === "object" && n?.uiid,
                                )
                                .map((n) => n.uiid);

                              const others = isMatched?.notes.filter(
                                (n) => !(n && typeof n === "object" && n?.uiid),
                              );
                              const merged = [...uiids, ...others];
                              getHoveredNotes(merged);
                            }}
                            onMouseLeave={() => setHoveredNotes([])}
                          >
                            <SmartTooltip
                              description={
                                Array.isArray(hoveredNotes) &&
                                hoveredNotes?.length > 0 ? (
                                  <div className="flex flex-col gap-2">
                                    {hoveredNotes?.map((hoveredNote, i) => (
                                      <p key={i}>
                                        "{hoveredNote?.note || ""}" by{" "}
                                        {formatWords2(
                                          hoveredNote?.addedBy?.firstName,
                                        ) || ""}{" "}
                                        on{" "}
                                        {dateFormator(
                                          convertFromUTC(hoveredNote?.addedOn),
                                          "datetime-ampm",
                                        ) || ""}
                                      </p>
                                    ))}
                                  </div>
                                ) : (
                                  "Add note"
                                )
                              }
                              noicon
                            >
                              <DualIcon
                                icon="chat"
                                size="sm"
                                badgeIconColor={
                                  matchingCandidatesMonster?.find((c) =>
                                    (c?.resumeIds || []).some(
                                      (r) => r?.id === data?.resumeId,
                                    ),
                                  )?.notes?.length > 0
                                    ? "bg-success"
                                    : "bg-dark"
                                }
                                onClick={() => {
                                  const matchedObject =
                                    matchingCandidatesMonster?.find((c) =>
                                      (c?.resumeIds || []).some(
                                        (r) => String(r?.id) === String(data?.resumeId),
                                      ),
                                    );

                                  if (matchedObject) {
                                    setNotesData(matchedObject);
                                    setNotesModal(true);
                                  }
                                }}
                              />
                            </SmartTooltip>
                          </div>
                        )}
                      </div>
                      {/* <div className="font-semibold text-[18px] text-black">
                  {data.name}
                </div> */}
                      <div className="text-[12px] text-neutrals-500 pl-1">
                        {highlightKeywords(data.previousJobTitle, keywords)}
                      </div>
                      <div className="flex items-center gap-1 text-[14px] text-neutrals-500 mt-1">
                        <span className="material-icons !text-[16px]">
                          location_on
                        </span>
                        {data.location}
                      </div>
                      <div className="text-sm">
                        {highlightKeywords(data.jobDescription, keywords)}
                      </div>
                      <Divider className="my-5" />
                      <div className="grid md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-5">
                        {data.lastUpdate && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="calendar_month"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Resume updated</div>
                              <div>{data.lastUpdate}</div>
                            </div>
                          </div>
                        )}
                        {data.highestEducation && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="menu_book"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Highest Education</div>
                              <div>{data.highestEducation}</div>
                            </div>
                          </div>
                        )}
                        {data.jobTitle && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="business_center"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Target Job Title</div>
                              <div>
                                {highlightKeywords(data.jobTitle, keywords)}
                              </div>
                            </div>
                          </div>
                        )}
                        {data.salary && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="$"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Desired Salary</div>
                              <div>{data.salary}</div>
                            </div>
                          </div>
                        )}
                        {data.relocation && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="moved_location"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Relocation</div>
                              <div>{data.relocation}</div>
                            </div>
                          </div>
                        )}
                        {data.location && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="person_4"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Authorization</div>
                              <div>{data.location}</div>
                            </div>
                          </div>
                        )}
                        {data.jobType && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="business_center"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Desired Job Type</div>
                              <div>{data.jobType}</div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex justify-center py-8">
              <NoData />
            </div>
          )}
        </>
      )}
      {query?.searchType !== "classic" && (
        <>
          {/* Select All Checkbox */}
          {gridData?.length ? (
            <div className="mb-2 flex items-center gap-2">
              <FormFieldSet
                type="checkbox"
                noTitle
                options={[{ label: "", value: "all" }]}
                values={
                  internalSelected.length === gridData.length ? ["all"] : []
                }
                onChange={handleSelectAll}
                multiple
              />
              <span className="text-[14px] text-neutrals-500">Select all</span>
            </div>
          ) : (
            ""
          )}

          {/* Candidate Cards */}
          {gridData?.length ? (
            <div className="flex flex-col gap-2">
              {gridData.map((data, index) => (
                <div
                  key={index}
                  className="flex items-start border-gray-300 border rounded-md p-3 shadow-lg bg-white relative"
                >
                  {/* Left Section */}
                  <div className="flex items-start gap-3 ">
                    <FormFieldSet
                      type="checkbox"
                      noTitle
                      options={[{ label: "", value: data.applicantId }]}
                      values={
                        internalSelected.includes(data.applicantId)
                          ? [data.applicantId]
                          : []
                      }
                      onChange={() => handleSelect(data.applicantId)}
                      multiple
                    />

                    {matchingCandidatesMonster?.some((c) =>
                      c.resumeIds?.some((r) => r.id === data.resumeId),
                    ) && (
                      <div className="absolute right-0 top-0 p-2 text-primary-500 text-sm bg-primary-50">
                        Profile Migrated
                      </div>
                    )}

                    <div>
                      <div className="flex gap-2">
                        <div
                          className="inline-flex flex-col items-center justify-center 
                               bg-success-600 text-white text-xs font-semibold px-2 py-1 rounded-md leading-tight"
                        >
                          <span className="text-sm font-semibold">{data?.Relevance}</span>
                          <span className="text-[10px]  tracking-wide">match</span>
                        </div>
                        <PageTitle title={data.name} tag="h5" />
                        <SmartTooltip description={"View Resume"} noicon>
                          <Button
                            type="icon"
                            size="sm"
                            variant="text"
                            icon="visibility"
                            color="black"
                            onClick={() => {
                              setDetailsDrawer(true);
                              setMonsterClassicApplicantId(data?.applicantId);
                            }}
                          />
                        </SmartTooltip>
                        {matchingCandidatesMonster?.find((c) =>
                          (c?.resumeIds || []).some(
                            (r) => r?.id === data?.resumeId,
                          ),
                        )?.notes?.length > 0 && (
                          <div
                            onMouseEnter={() => {
                              const isMatched = matchingCandidatesMonster?.find(
                                (c) =>
                                  (c?.resumeIds || []).some(
                                    (r) => r?.id === data?.resumeId,
                                  ),
                              );
                              const uiids = isMatched?.notes
                                .filter(
                                  (n) => n && typeof n === "object" && n?.uiid,
                                )
                                .map((n) => n.uiid);

                              const others = isMatched?.notes.filter(
                                (n) => !(n && typeof n === "object" && n?.uiid),
                              );
                              const merged = [...uiids, ...others];
                              getHoveredNotes(merged);
                            }}
                            onMouseLeave={() => setHoveredNotes([])}
                          >
                            <SmartTooltip
                              description={
                                Array.isArray(hoveredNotes) &&
                                hoveredNotes?.length > 0 ? (
                                  <div className="flex flex-col gap-2">
                                    {hoveredNotes?.map((hoveredNote, i) => (
                                      <p key={i}>
                                        "{hoveredNote?.note || ""}" by{" "}
                                        {formatWords2(
                                          hoveredNote?.addedBy?.firstName,
                                        ) || ""}{" "}
                                        on{" "}
                                        {dateFormator(
                                          convertFromUTC(hoveredNote?.addedOn),
                                          "datetime-ampm",
                                        ) || ""}
                                      </p>
                                    ))}
                                  </div>
                                ) : (
                                  "Add note"
                                )
                              }
                              noicon
                            >
                              <DualIcon
                                icon="chat"
                                size="sm"
                                badgeIconColor={
                                  matchingCandidatesMonster?.find((c) =>
                                    (c?.resumeIds || []).some(
                                      (r) => r?.id === data?.resumeId,
                                    ),
                                  )?.notes?.length > 0
                                    ? "bg-success"
                                    : "bg-dark"
                                }
                                onClick={() => {
                                  const matchedObject =
                                    matchingCandidatesMonster?.find((c) =>
                                      (c?.resumeIds || []).some(
                                        (r) => String(r?.id) === String(data?.resumeId),
                                      ),
                                    );

                                  if (matchedObject) {
                                    setNotesData(matchedObject);
                                    setNotesModal(true);
                                  }
                                }}
                              />
                            </SmartTooltip>
                          </div>
                        )}
                      </div>
                      {/* <div className="font-semibold text-[18px] text-black">
                  {data.name}
                </div> */}
                      <div className="text-[12px] text-neutrals-500 pl-1">
                        {highlightKeywords(data.previousJobTitle, keywords)}
                      </div>
                      <div className="flex items-center gap-1 text-[14px] text-neutrals-500 mt-1">
                        <span className="material-icons !text-[16px]">
                          location_on
                        </span>
                        {data.location}
                      </div>
                      <div className="flex gap-2 mt-2">
                        <div>Skills</div>
                        {/* <Button
                        type="icon"
                        size="sm"
                        variant="text"
                        icon={openSkillsModal ? "visibility_off" : "visibility"}
                        color="black"
                        onClick={() => setOpenSkillsModal((prev) => !prev)}
                      /> */}
                        <Button
                          type="icon"
                          size="sm"
                          variant="text"
                          icon={
                            openSkillIds.includes(data.applicantId)
                              ? "visibility_off"
                              : "visibility"
                          }
                          color="black"
                          onClick={() => toggleSkill(data.applicantId)}
                        />
                      </div>
                      {/* <div className="flex flex-wrap gap-2 my-3">
                      <span className="text-xs bg-primary-50 text-black px-2 py-1 rounded-md border border-primary-200">
                        Record Keeping :{" "}
                        <span className="text-primary-500">5.6 years</span>{" "}
                      </span>
                      <span className="text-xs bg-primary-50 text-black px-2 py-1 rounded-md border border-primary-200">
                        Training Teaching :{" "}
                        <span className="text-primary-500">5.6 years</span>
                      </span>
                      <span className="text-xs bg-primary-50 text-black px-2 py-1 rounded-md border border-primary-200">
                        Problem Solving skills :{" "}
                        <span className="text-primary-500">3 years</span>
                      </span>
                    </div> */}
                      {/* <Divider className="my-5" /> */}
                      <div className="grid lg:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-6 gap-5">
                        {data.lastUpdate && (
                          <div className="flex justify-start items-center gap-2">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="calendar_month"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1 text-xs">
                              <div>Resume updated</div>
                              <div>{data.lastUpdate}</div>
                            </div>
                          </div>
                        )}
                        {data.highestEducation && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="menu_book"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Highest Education</div>
                              <div>{data.highestEducation}</div>
                            </div>
                          </div>
                        )}
                        {data.jobTitle && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="business_center"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Target Job Title</div>
                              <div>
                                {highlightKeywords(data.jobTitle, keywords)}
                              </div>
                            </div>
                          </div>
                        )}
                        {data.salary && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="$"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Desired Salary</div>
                              <div>{data.salary}</div>
                            </div>
                          </div>
                        )}
                        {data.relocation && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="moved_location"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Relocation</div>
                              <div>{data.relocation}</div>
                            </div>
                          </div>
                        )}
                        {data.location && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="person_4"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Authorization</div>
                              <div>{data.location}</div>
                            </div>
                          </div>
                        )}
                        {data.jobType && (
                          <div className="flex justify-start items-center gap-2 text-xs">
                            <div>
                              <Button
                                type="icon"
                                size="sm"
                                variant="text"
                                icon="business_center"
                                color="black"
                              />
                            </div>
                            <div className="grid grid-cols-1">
                              <div>Desired Job Type</div>
                              <div>{data.jobType}</div>
                            </div>
                          </div>
                        )}
                      </div>
                      {openSkillIds.includes(data.applicantId) && (
                        <>
                          {gridData[index]?.skills?.length > 0 ? ( //modify with skills server data
                            <div className="bg-[#F9F9F9] p-3 my-3 rounded-md">
                              <div>Skills</div>
                              <div className="grid md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-6 gap-5">
                                {gridData[index].skills.map((s, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-center gap-2 justify-between bg-primary-50 px-3 py-1 rounded text-xs border border-primary-200"
                                  >
                                    <div className="font-medium line-clamp-1 text-black">
                                      {highlightKeywords(s.name, keywords)}
                                    </div>
                                    <div className="text- primary-500 font-semibold">
                                      {s.yearsUsed} Yrs
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <div className="mt-3 text-xs text-gray-500 italic">
                              No Skills
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex justify-center py-8">
              <NoData />
            </div>
          )}
        </>
      )}
      {/* <Modal
        title="Skills"
        isOpen={openSkillsModal}
        onClose={() => setOpenSkillsModal(false)}
        width="max-w-4xl"
        titleColor="warning"
      >
        <div>dhjkfdkjs</div>
      </Modal> */}
      <AddNoteModal
        key={noteData?.candidateId?.uiid || noteData?.uiid}
        isOpen={noteModal}
        onClose={() => setNotesModal(false)}
        data={noteData}
        source={source}
      />
    </div>
  );
};

export default TableGridMonsterToggleView;
